import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/files-v1/files-v1-index';

@Injectable({
    providedIn: 'root'
  })
export class FilesV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'files-v1';
    menuTitle: string = "File Upload";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns FilesV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.FilesV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsFilesV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsFilesV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsFilesV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsFilesV1FieldComponent> {
        return fieldComponents.SettingsFilesV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillFilesV1FieldComponent> {
        return fieldComponents.FillFilesV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewFilesV1FieldComponent>{ 
        return fieldComponents.ViewFilesV1FieldComponent;
    }


}